export default __webpack_public_path__ + "static/media/keypad.ffbee072.svg";